/* Approved revised TSH Control art. Broad cut-paper athlete, two defined
   shoulders, connected low elbows and simple palms. Shared across both pages. */
(() => {
  if (window.TSHControlJuggle) return;
  let textures;
  function grain(rgb,seed) {
    const c=document.createElement('canvas');c.width=c.height=128;
    const g=c.getContext('2d'),pixels=g.createImageData(128,128);
    for(let i=0;i<pixels.data.length;i+=4) {
      seed=(Math.imul(seed,1664525)+1013904223)>>>0;
      const noise=((seed>>>24)/255-.5)*20;
      for(let k=0;k<3;k++)pixels.data[i+k]=rgb[k]+noise;
      pixels.data[i+3]=255;
    }
    g.putImageData(pixels,0,0);return c;
  }
  const fill=(ctx,d,color)=>{ctx.fillStyle=color;ctx.fill(new Path2D(d))};
  function pose(time) {
    const t=((time%1)+1)%1,half=t*2,rightward=half<1,q=half%1;
    const flight=.78,u=Math.min(1,q/flight),catchPhase=Math.max(0,(q-flight)/(1-flight));
    const dip=24*Math.sin(Math.PI*catchPhase);
    const left={x:185,y:327+(rightward?0:dip)};
    const right={x:460,y:307+(rightward?dip:0)};
    const from=rightward?{x:185,y:327}:{x:460,y:307};
    const to=rightward?{x:460,y:307}:{x:185,y:327};
    const ball={x:from.x+(to.x-from.x)*u,y:from.y+(to.y-from.y)*u-27-245*4*u*(1-u)+dip};
    return {left,right,ball,head:(ball.x-330)/242*.08};
  }
  function draw(ctx,t) {
    textures ||= [grain([22,21,19],407),grain([248,73,27],173),grain([51,181,191],827)];
    const [ink,orange,cyan]=textures.map(texture=>ctx.createPattern(texture,'repeat'));
    const p=pose(t);
    ctx.save();
    // Both shoulders extend beyond the neck. A distinct left shoulder shelf
    // prevents the far arm from reading as a continuation of the neck.
    fill(ctx,'M 275 226 L 331 223 L 373 247 L 351 320 L 371 387 L 431 522 L 356 529 L 315 429 L 264 475 L 264 528 L 189 528 L 195 450 L 261 364 L 246 294 L 227 255 L 240 234 Z',ink);
    // Short, integrated neck; a slightly turned angular head rather than a floating oval.
    fill(ctx,'M 280 209 L 321 200 L 328 244 L 274 243 Z',ink);
    ctx.save();ctx.translate(304,216);ctx.rotate(p.head);
    fill(ctx,'M -41 -62 L -29 -79 L 2 -85 L 25 -78 L 34 -60 L 33 -43 L 42 -31 L 29 -28 L 24 -8 L 6 1 L -21 -7 L -36 -26 Z',ink);
    ctx.restore();
    // Joined thick contours avoid seams and self-intersection at the elbow.
    const limb=(sx,sy,ex,ey,hand)=>{
      ctx.strokeStyle=ink;ctx.lineWidth=42;ctx.lineJoin='bevel';ctx.lineCap='butt';
      ctx.beginPath();ctx.moveTo(sx,sy);ctx.lineTo(ex,ey);
      ctx.lineTo(hand.x,hand.y+10);ctx.stroke();
      fill(ctx,`M ${hand.x-28} ${hand.y-4} L ${hand.x-17} ${hand.y}
        L ${hand.x+16} ${hand.y} L ${hand.x+28} ${hand.y-6}
        L ${hand.x+29} ${hand.y+10} L ${hand.x+13} ${hand.y+20}
        L ${hand.x-15} ${hand.y+20} L ${hand.x-30} ${hand.y+8} Z`,ink);
    };
    const l=p.left;
    limb(249,260,213,385,l);
    const r=p.right;
    limb(353,257,412,373,r);
    ctx.save();ctx.translate(p.ball.x,p.ball.y);
    fill(ctx,'M -24 -6 L -20 -18 L -9 -24 L 6 -25 L 19 -17 L 25 -4 L 22 11 L 12 22 L -2 25 L -17 18 L -25 5 Z',orange);
    ctx.restore();
    fill(ctx,'M 130 527 L 469 527 L 470 568 L 128 570 Z',cyan);
    ctx.restore();return p;
  }
  window.TSHControlJuggle={draw,pose};
})();

/* Mobile loops while visible; desktop demonstrations remain input-triggered. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 600px)');
  const controllers = new Set();
  let stopActive = () => {};
  const bind = root => {
    if (root.dataset.motionBound || root.dataset.motionEnabled !== 'true') return;
    root.dataset.motionBound = 'true';
    root.querySelectorAll('[data-motion]').forEach(tab => {
      const kind = tab.dataset.motion;
      if (!['breath','foundation','bounce','control','flow'].includes(kind)) return;
      const img = tab.querySelector('.tsh-pillar-figure');
      const stage = document.createElement('span');
      stage.className = 'tsh-pillar-stage';
      img.before(stage); stage.append(img);
      const canvas = document.createElement('canvas');
      canvas.width = 660; canvas.height = 660;
      canvas.setAttribute('aria-hidden','true');
      canvas.className = 'tsh-pillar-motion';
      stage.append(canvas);
      const ctx = canvas.getContext('2d');
      let layers, pending, raf, active = false, generation = 0, visible = false;
      const load = () => kind === 'control' ? Promise.resolve() : (pending ||= Promise.all(['base','body','accent'].map(layer =>
        new Promise((resolve,reject) => {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.onload = () => resolve(image);
          image.onerror = reject;
          image.src = tab.dataset['motion'+layer[0].toUpperCase()+layer.slice(1)];
        })
      )).then(values => layers = values));
      const stop = () => {
        active = false; generation++; cancelAnimationFrame(raf);
        stage.classList.remove('is-playing');
        tab.dataset.animating = 'false';
      };
      const render = t => {
        if (kind === 'control') {
          ctx.clearRect(0,0,660,660);
          window.TSHControlJuggle.draw(ctx,(t+.12)%1);
          return;
        }
        const [base,body,accent] = layers;
        ctx.clearRect(0,0,660,660);
        ctx.drawImage(base,0,0);
        const wave = Math.sin(Math.PI*t)**2;
        if (kind === 'breath') {
          // Chest expands while the seated base and legs remain grounded.
          for (let y=0;y<660;y+=2) {
            const chest = Math.exp(-Math.pow((y-365)/108,2));
            const scale = 1 + .08*wave*chest;
            ctx.drawImage(body,0,y,660,2,330-330*scale,y,660*scale,2.5);
          }
          ctx.globalAlpha = .65+.35*wave;
          ctx.drawImage(accent,-24*wave,0); ctx.globalAlpha=1;
        } else if (kind === 'foundation') {
          // Squat/load: upper body lowers, knee region flexes, feet stay planted.
          for (let y=0;y<660;y+=2) {
            const anchor = y<360?1:Math.max(0,(550-y)/190);
            const wide = 1+.05*wave*Math.exp(-Math.pow((y-420)/70,2));
            ctx.drawImage(body,0,y,660,2,330-330*wide,y+28*wave*anchor,660*wide,3);
          }
        } else if (kind === 'bounce') {
          const cycle = t*2;
          const lift = Math.max(0,Math.sin(cycle*Math.PI*2))*38;
          const compression = Math.max(0,-Math.sin(cycle*Math.PI*2))*.065;
          ctx.save();ctx.translate(330,535-lift);ctx.scale(1+compression*.4,1-compression);
          ctx.drawImage(body,-330,-535);ctx.restore();
        } else {
          ctx.drawImage(body,0,0);
          // The rope wave travels away from the fixed hand.
          for(let x=0;x<660;x+=2) {
            const amount=Math.max(0,(x-420)/240);
            const dy=24*amount*Math.sin(x*.024-t*Math.PI*6)*Math.sin(Math.PI*t);
            ctx.drawImage(accent,x,0,2,660,x,dy,2.5,660);
          }
        }
      };
      const play = async () => {
        if(reduced.matches || document.hidden) return;
        const loop = mobile.matches;
        if(loop && (!visible || active)) return;
        if(!loop) { stopActive(); stopActive=stop; }
        active=true;
        const ticket=++generation;
        try { await load(); } catch { stop(); return; }
        if(ticket!==generation) return;
        if(!active || reduced.matches) { stop(); return; }
        stage.classList.add('is-playing');tab.dataset.animating='true';
        const start=performance.now();
        const frame = now => {
          if(!active || reduced.matches || document.hidden) { stop(); return; }
          const elapsed=(now-start)/3400;
          const t=loop ? elapsed%1 : Math.min(1,elapsed);
          render(t);
          if(loop || t<1) raf=requestAnimationFrame(frame); else stop();
        };
        raf=requestAnimationFrame(frame);
      };
      tab.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')play();});
      tab.addEventListener('focus',play);
      tab.addEventListener('click',play);
      tab.addEventListener('pointerleave',e=>{if(!mobile.matches && e.pointerType==='mouse')stop();});
      tab.addEventListener('blur',()=>{if(!mobile.matches)stop();});
      const sync = () => {
        stop();
        if(mobile.matches && visible && !reduced.matches && !document.hidden) play();
      };
      controllers.add(sync);
      const observer=new IntersectionObserver(entries=>{
        visible=entries[0].isIntersecting;
        if(!visible) stop(); else if(mobile.matches) play();
      });
      observer.observe(stage);
      root.addEventListener('shopify:section:unload',()=>{
        stop();observer.disconnect();controllers.delete(sync);
      },{once:true});
    });
  };
  const init=()=>document.querySelectorAll('[data-tsh-section="philosophy"]').forEach(bind);
  const syncAll=()=>controllers.forEach(sync=>sync());
  reduced.addEventListener('change',syncAll);
  mobile.addEventListener('change',syncAll);
  document.addEventListener('visibilitychange',syncAll);
  document.addEventListener('shopify:section:load',init);
  init();
})();
